import Link from 'next/link'
import {Helmet} from "react-helmet";
import Box from "../../components/box/Box";
import {getBahabinText} from "../../util/DominantUtil";

export const tvs = {
    'بلومبرگ': 'https://liveprodusphoenixeast.akamaized.net/USPhx-HD/Channel-TX-USPhx-AWS-virginia-1/Source-USPhx-16k-1-s6lk2-BP-07-04-jZwxsD5tnuA_live.m3u8',
    'ایران کالا': 'https://liveproxy.splus.ir/tva_iran-kala/index.m3u8',
    'سی بی اس': 'https://cbsnhls-i.akamaihd.net/hls/live/264710/cbsn_hlsprod_2/master_1200.m3u8',
    'شبکه خبر': 'https://liveproxy.splus.ir/tva_IRINN/index.m3u8',
    'فاکس': 'https://fox-foxnewsnow-samsungus.amagi.tv/playlist.m3u8',
    // 'شبکه ورزش': 'https://s1-cloud.irib.ir/securelive3/varzeshhd/varzeshhd.m3u8?s=RKtnnJVeBLv0mPf4wFVrSA&t=1646234576',
    // 'اس  بی ان': 'https://sonlife7-i.akamaihd.net/hls/live/585011/ch7/ch70/ch70.m3u8',
//    https://liveproxy.splus.ir/tva_IRIB-TV3/index.m3u8
//    'بلومبرگ اروپا': 'https://liveproxy.splus.ir/tva_iran-kala/index.m3u8',
//    'cnbc': 'https://rtmp.livenewsof.com/hls/business.m3u8'
}

export default function About() {

    const t = 'پخش زنده';
    return (
        <Box disableHeader={true} loaded={true} leftBoxClassName={'w-100 bg-white'}
             height={900}
             linksMap={{
                 'last': 'پخش زنده',
             }}
             height={'h-100'}>

            <Helmet
                title={t + getBahabinText()}
                meta={[{name: 'description', content: t}, {
                    property: 'twitter:description',
                    content: "لیست شبکه های تلویزیونی اقتصاد ایران/جهان"
                }, {property: 'og:title', content: t}]}
            />

            <div className="row p-2">
                {Object.keys(tvs).map(x =>
                    <Link href={`/live-tv/${x}`}>
                        <div className="col-md pb-3 text-center cursor-pointer">
                            <div className='' style={{width: '100px !important'}}>
                                <img
                                    width={100}
                                    height={100}
                                    alt={x}
                                    src={'/images/live-tv/' + x + '.png'}
                                    className='img-responsive mx-auto'
                                />
                            </div>
                            <div className='pt-2'><span>{x}</span></div>
                        </div>
                    </Link>
                )}
            </div>
        </Box>
    )
}